"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(data, config) {
  return "<amp-twitter width=\"375\" height=\"472\" layout=\"responsive\" data-tweetid=\"".concat(data.id, "\"></amp-twitter>");
};

exports["default"] = _default;